import { Outlet } from 'react-router';
import styles from './AuthSplitLayout.module.css';
import AuthScreenImage from '../../assets/images/auth_screen_image.png';

/**
 * Renders the shared V2 authentication shell with the form content on the left
 * and the branded lifestyle image panel on the right.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - Optional auth form content rendered before the route outlet.
 * @returns {JSX.Element} The split authentication layout.
 */
const AuthSplitLayout = ({ children }) => {
	return (
		<div className={styles.authWrapper}>
			<div className={styles.authFormPanel}>
				<div className={styles.authFormContainer}>
					{children}
					<Outlet />
				</div>
			</div>
			<div className={styles.authImagePanel}>
				<div className={styles.authImageInner}>
					<img
						src={AuthScreenImage}
						alt="People enjoying life together"
						className={styles.authImage}
						loading="eager"
					/>
				</div>
			</div>
		</div>
	);
};

export default AuthSplitLayout;
